/**
 * Converts newline characters in a string to HTML <br> tags
 * @param str - The input string that may contain newline characters
 * @returns The string with newlines replaced by <br> tags
 */
export const newLineToBr = (str: string | undefined): string => {
  if (str === undefined) return '';
  return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
};
